import { Button } from '@cluey/cluey-components';
import moment from 'moment';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { generatePath, useHistory, useParams } from 'react-router';

import { ReactComponent as CheckIcon } from '../../../assets/images/icon-outline-checked.svg';
import { ContainerLayout } from '../../../common/hub/ContainerLayout';
import { ShadowContainer } from '../../../components/ShadowContainer';
import { FormFlowProps } from '../../../types/hubInterfaces';
import { InitialState } from '../../../types/hubTypes';
import { DATE_FORMAT_TYPE_12, SESSION_TIME_FORMAT } from '../../../util/constants';
import { PATH_HUB_ENROLMENT_DETAIL, PATH_HUB_SUPPORT } from '../../../util/pagePath';
import { usePageHeader } from '../../../v2/app-shell/usePageHeader';
import { useRescheduleSessionState } from './useRescheduleSessionState';

interface Props {
  formFlowProps: FormFlowProps<{
    scheduleDate: string;
    sessionDuration: number;
    isTempTutor: boolean;
  }>;
}

type State = {
  scheduleDate: string;
  isTempTutor: boolean;
};

const HubRescheduleSessionSuccessPage = ({ formFlowProps }: Props) => {
  console.log(formFlowProps);
  const history = useHistory<State>();
  const {
    location: { state },
  } = history;
  //   @ts-ignore
  const { sessionId } = useParams();
  const { setHeader } = usePageHeader();

  useEffect(() => {
    setHeader({
      label: 'Reschedule upcoming session',
      showIcon: false,
      showBackButton: true,
      onBackClick: () => history.push(PATH_HUB_SUPPORT),
    });
  }, [history, setHeader]);

  const { scheduleDate, isTempTutor } = state;
  const { enrolmentId, studentName, enrolmentSubject } = useSelector(
    (state: InitialState) => state.hubEnrolmentDetailPage
  );
  const [firstname] = studentName?.split(' ');
  const nameWithSubject = `${firstname}'s ${enrolmentSubject}`;
  const { timezone } = useRescheduleSessionState();
  const nextSessionDay = moment(scheduleDate).tz(timezone).format(DATE_FORMAT_TYPE_12);
  const nextSessionStartTime = moment(scheduleDate).tz(timezone).format(SESSION_TIME_FORMAT);

  return (
    <ContainerLayout>
      <ShadowContainer className="flex flex-col items-center gap-9 !rounded-3xl bg-white p-6 md:!p-10">
        <div className="flex flex-col items-center gap-2">
          <div className="flex h-[60px] w-[60px] items-center justify-center rounded-full">
            <CheckIcon className="text-white" width={60} height={60} />
          </div>
          <h1 className="text-center font-merriweather text-[32px] font-bold text-grey-600">Change confirmed</h1>
        </div>
        {isTempTutor ? (
          <p className="text-center text-lg text-grey-600">
            {nameWithSubject} session on {nextSessionDay} at {nextSessionStartTime} will go ahead with a temporary
            tutor.
          </p>
        ) : (
          <p className="text-center text-lg text-grey-600">
            We have changed your upcoming session time, you will see it reflected on your enrolment and session details
            soon. You will also receive an email confirming the details soon.
          </p>
        )}
        <Button
          onClick={() => {
            history.push(generatePath(`${PATH_HUB_ENROLMENT_DETAIL}?token=${enrolmentId}`, { sessionId }));
          }}
          size="sm"
          appearance="reverse"
          className="flex h-10 w-auto items-center justify-center !border text-sm !font-medium tracking-wide text-grey-400 md:text-base"
        >
          View {nameWithSubject} enrolment
        </Button>
      </ShadowContainer>
    </ContainerLayout>
  );
};

export default HubRescheduleSessionSuccessPage;
